import React from "react";
import { ExternalLink } from "lucide-react";
import { normalizeExternalUrl } from "./enquiry-helpers";

type EnquiryLinkedInLinkProps = {
    url: string;
};

export const EnquiryLinkedInLink = ({ url }: EnquiryLinkedInLinkProps) => {
    const href = normalizeExternalUrl(url);

    return (
        <div className="flex items-start gap-2">
            <span className="break-all text-sm text-gray-800">{url}</span>
            <a
                href={href}
                target="_blank"
                rel="noopener noreferrer"
                className="mt-0.5 shrink-0 rounded p-1 text-gray-400 transition hover:bg-violet-50 hover:text-violet-600"
                aria-label="Open LinkedIn profile"
                title="Open LinkedIn"
            >
                <ExternalLink className="h-3.5 w-3.5" />
            </a>
        </div>
    );
};